import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../components/NewView/Common/Loader";
const CourseGrafComponent = React.lazy(() =>
  import("../../../components/NewView/RootComponents/courses/CourseGrafComponent")
);
const CourseGrafPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>
            YellowHub
          </title>
          <meta
            name="description"
            content="Next LMS - Professional LMS Online Education Course
            React Template"
          />
        </Helmet>
        <CourseGrafComponent />
      </Suspense>
    </Fragment>
  );
};

export default CourseGrafPage;
